<template>
  <div class="box8-page">
    <img
      src="../../../assets/coursePage/inseec/box8/footer-qrcode.png"
      alt=""
    />
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {};
    },
  };
</script>

<style lang="scss" scoped>
  .box8-page {
    img {
      width: 100%;
    }
  }
</style>
